// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  /* display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; */
  background-color: #fafafa; /* Background color for the entire page */
}

.center {
  align-items: center;
  justify-content: center;
  align-content: center;
}

.button-del {
  position: absolute;
  width: 50px;
  height: 100%;
  right: 0;
  border: none;
  cursor: pointer;
  background-color: #ffffff00;
  transition: color 0.3s ease;
}

.button-del:hover {
  color: #c2c2c2;
}

.button-del:active {
  color: #fff;
}

.button-del:disabled {
  cursor: not-allowed;
  color: rgb(216, 216, 216);
}

.loading-circle {
  border: 4px solid #f3f3f3; /* Light gray border */
  border-top: 4px solid #3498db; /* Blue border */
  border-radius: 50%;
  width: 12px;
  height: 12px;
  animation: spin 1s linear infinite; /* Animation */
  margin-right: 10px;
}

.loading-done {
  width: 30px;
  height: 30px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-done::before {
  content: "\\2713";
  font-size: 25px;
  font-weight: bold;
  color: #4caf50;
}

.loading-text {
  margin-left: 10px;
  font-size: 0.875rem;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV;;;kBAGgB;EAChB,yBAAyB,EAAE,yCAAyC;AACtE;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB,EAAE,sBAAsB;EACjD,6BAA6B,EAAE,gBAAgB;EAC/C,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC,EAAE,cAAc;EAClD,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["body {\n  margin: 0;\n  padding: 0;\n  /* display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh; */\n  background-color: #fafafa; /* Background color for the entire page */\n}\n\n.center {\n  align-items: center;\n  justify-content: center;\n  align-content: center;\n}\n\n.button-del {\n  position: absolute;\n  width: 50px;\n  height: 100%;\n  right: 0;\n  border: none;\n  cursor: pointer;\n  background-color: #ffffff00;\n  transition: color 0.3s ease;\n}\n\n.button-del:hover {\n  color: #c2c2c2;\n}\n\n.button-del:active {\n  color: #fff;\n}\n\n.button-del:disabled {\n  cursor: not-allowed;\n  color: rgb(216, 216, 216);\n}\n\n.loading-circle {\n  border: 4px solid #f3f3f3; /* Light gray border */\n  border-top: 4px solid #3498db; /* Blue border */\n  border-radius: 50%;\n  width: 12px;\n  height: 12px;\n  animation: spin 1s linear infinite; /* Animation */\n  margin-right: 10px;\n}\n\n.loading-done {\n  width: 30px;\n  height: 30px;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.loading-done::before {\n  content: \"\\2713\";\n  font-size: 25px;\n  font-weight: bold;\n  color: #4caf50;\n}\n\n.loading-text {\n  margin-left: 10px;\n  font-size: 0.875rem;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
